import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "../../../layouts/AppLayout";
import { lazy, ReactNode, useEffect, useState } from "react";
import {
  getHouseIdFromToken,
  getParentIdFromToken,
  fetchBalance,
  useAppDispatch,
  useAppSelector,
  DomainConfig,
  ACCEPT_TERMS_ROUTE,
  ACCESS_REDIRECT_ROUTE,
  LOGIN_ROUTE,
  SIGN_UP_ROUTE,
  SPORTS_BOOK_ROUTE,
  getDomainConfig,
  getContactList,
  getAdminWhatsAppNumber,
  setAllowedConfig,
  getAllowedConfig,
  HOME_ROUTE,
  RESET_PASSWORD_ROUTE,
} from "@hypexone/uicore";
import { BRAND_DOMAIN } from "../../../constants/Branding";
// import AcceptTerms from "../AcceptTerms/AcceptTerms";
// import SignUpPage from "../../pages/SignUpPage";
// import ForgotPasswordPage from "../../pages/ForgotPassword";
// import Footer from "../Footer/Footer";
// import NoAccessPage from "../../pages/AccessRedirect/AccessRedirect";
import { pnService } from "../../../webSocket/SocketServices";
// import ChangePasswordTab from "../user-menu/my-profile/SetPassword";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { CHANGE_PASSWORD_ROUTE } from "../../../utils/constants/routes";
// import { depositEvent } from "../../../utils/facebookPixelEvent";
// import Maintenance from "../../pages/Maintenance";
// import RegisterPage from "../../../register";
// const ChangePassword = lazy(
//   () => import("../../components/user-menu/my-profile/ChangePassword")
// );
import { isIOS, isMobile } from "react-device-detect";
import YuviGames from "../YuviGames/YuviGames";
import HomePage from "../../pages/HomePage";
import MobileLoginPage from "../../pages/MobileLoginPage";
import NoAccessPage from "../../pages/NoAccessPage";
import ResetPassword from "../../pages/ResetPassword/ResetPassword";
import SignUpForm from "../../pages/SignUp/SignUpForm";
import AuthSignUp from "../../pages/Register";
import CasinoIFrame from "../iframes/CasinoIFrame";
import SportsbookIFrame from "../iframes/SportsbookIFrame";
import SignUpRouteHandler from "../../pages/SignUpRouteHandler";
import { useSignUpModal } from "../../context/SignUpModalContext";
import { useResendEmailModal } from "../../context/ResendEmailModalContext";
import { useForgotPasswordModal } from "../../context/ForgotPasswordModalContext";
import SignUpModal from "../../pages/SignUp/SignUpModal";
import ResendEmailModal from "../../pages/ResendEmail/ResendEmailModal";
import ForgotPasswordModal from "../../pages/ForgotPassword/ForgotPasswordModal";
import { MAINTENANCE_ROUTE } from "../../../utils/constants/routes";
import MaintenanceWrapper from "../../../components/MaintenanceWrapper";
import Maintenance from "../../pages/Maintenance/Maintenance";

export { MAINTENANCE_ROUTE };

const GlobalModals = () => {
  const { isSignUpModalOpen, setSignUpModalOpen } = useSignUpModal();
  const { isResendEmailModalOpen, setResendEmailModalOpen } = useResendEmailModal();
  const { isForgotPasswordModalOpen, setForgotPasswordModalOpen } = useForgotPasswordModal();
  return (
    <>
      {isSignUpModalOpen && (
        <SignUpModal
          onClose={() => setSignUpModalOpen(false)}
          onSuccess={() => setSignUpModalOpen(false)}
        />
      )}
      {isResendEmailModalOpen && (
        <ResendEmailModal onClose={() => setResendEmailModalOpen(false)} />
      )}
      {isForgotPasswordModalOpen && (
        <ForgotPasswordModal onClose={() => setForgotPasswordModalOpen(false)} />
      )}
    </>
  );
};

const rootLevelRoutes: { path: string; component: ReactNode }[] = [
  {
    path: LOGIN_ROUTE,
    component: <MobileLoginPage />,
  },
  {
    path: SIGN_UP_ROUTE,
    component: <SignUpRouteHandler />,
  },
  {
    path: "/emailSignup",
    component: <AuthSignUp />,
  },
  {
    path: ACCEPT_TERMS_ROUTE,
    component: <ResetPassword />,
  },
  {
    path: RESET_PASSWORD_ROUTE,
    component: <ResetPassword />,
  },
  {
    path: ACCESS_REDIRECT_ROUTE,
    component: <NoAccessPage />,
  },
  {
    path: MAINTENANCE_ROUTE,
    component: <Maintenance />,
  },
  {
    path: "/dc/gamev1.1/:gamePath",
    component: <CasinoIFrame />,
  },
  {
    path: SPORTS_BOOK_ROUTE,
    component: <SportsbookIFrame />,
  },
  {
    path: HOME_ROUTE,
    component: <HomePage />,
  },
  {
    path: "/",
    component: <Navigate to="/home" replace />,
  },
];
const AppRoutes = () => {
  const dispatch = useAppDispatch();
  const { loggedIn, balanceSummary } = useAppSelector((state) => state.auth);
  const { balanceChanged } = useAppSelector((state) => state.common);
  const { pushNotifWSConnection } = useAppSelector((state) => state.catalog);

  const houseId = getHouseIdFromToken();
  const parentId = getParentIdFromToken();
  const accountId = sessionStorage.getItem("aid");

  useEffect(() => {
    if (loggedIn) {
      if (pushNotifWSConnection) {
        pnService.disconnectFromPushNotificationWS();
      }
      pnService.connectToPushNotification();
    }

    return () => {
      if (pushNotifWSConnection) {
        pnService.disconnectFromPushNotificationWS();
      }
    };
  }, [loggedIn]);

  useEffect(() => {
    if (
      loggedIn &&
      !window.location.pathname.includes("==") &&
      !window.location.pathname.includes("multi-markets")
    ) {
      pnService.subscribeWsForNotifications(false, houseId);
      pnService.subscribeWsForNotificationsPerAdmin(
        false,
        houseId,
        parentId,
        accountId
      );
    }
  }, [pushNotifWSConnection, loggedIn]);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchBalance());
    }
  }, [loggedIn, balanceChanged]);

  useEffect(() => {
    if (loggedIn && balanceSummary?.balance) {
      if (
        localStorage.getItem("campaignId") &&
        localStorage.getItem("balance") &&
        localStorage.getItem("balance") != balanceSummary?.balance
      ) {
        // depositEvent();
        localStorage.removeItem("balance");
        localStorage.removeItem("campaignId");
      }
    }
  }, [balanceSummary?.balance]);
  
  useEffect(() => {
    // dispatch(getAllowedConfig(loggedIn));
    dispatch(getDomainConfig(BRAND_DOMAIN));
    if (loggedIn) {
      dispatch(getAdminWhatsAppNumber(BRAND_DOMAIN));
    }
    dispatch(setAllowedConfig(31));
  }, [loggedIn]);

  return (
    <BrowserRouter>
      <Routes>
        {rootLevelRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.component} />
        ))}
        <Route key={"login"} path="*" Component={AppLayout} />
      </Routes>
      <GlobalModals />
    </BrowserRouter>
  );
};

export default AppRoutes;
